import apiClient from "../../service/apiClient";
import qs from "qs";
import { GetFiltersRequest } from "pages/admin-app/shared/models/request/get-filters-request";
import { GetFiltersResponse } from "pages/admin-app/shared/models/response/get-filters-response";
import { GetSortAndFilterRequest } from "pages/admin-app/shared/models/request/get-sort-filters-request";
import { GetEndUsersResponse } from "../models/response/get-end-users-response";
import { GetEndUserRequest } from "../models/request/get-end-user-request";
import { GetEndUserResponse } from "../models/response/get-end-user-response";
import { EditEndUserRequest } from "../models/request/edit-end-user-request";
import { EditEndUserResponse } from "../models/response/edit-end-user-response";
import { DeleteEndUserRequest } from "../models/request/delete-end-user-request";
import { DeleteEndUserResponse } from "../models/response/delete-end-user-response";
import { CreateEndUserRequest } from "../models/request/create-end-user-request";
import { CreateEndUserResponse } from "../models/response/create-end-user-response";
import { GetEndUsersRequest } from "../models/request/get-end-users-request";

export async function getEndUsers(
  request: GetSortAndFilterRequest
): Promise<GetEndUsersResponse> {
  const response = await apiClient.get<GetEndUsersResponse>(
    "/end-user/search",
    {
      params: {
        page: request.page,
        perPage: request.perPage,
        sortBy: request.sortBy,
        orderBy: request.orderBy,
        filters: request.filters,
        searchQuery: request.searchQuery,
      },
      paramsSerializer: (params) =>
        qs.stringify(params, { encode: true, arrayFormat: "brackets" }),
    }
  );
  return response.data;
}

export async function getPaginatedByNameEndUsers(
  request: GetEndUsersRequest
): Promise<GetEndUsersResponse> {
  const response = await apiClient.get<GetEndUsersResponse>(
    "/end-user/search-by-name",
    {
      params: {
        page: request.page,
        perPage: request.perPage,
        searchQuery: request.searchQuery,
      },
    }
  );
  return response.data;
}

export async function getEndUser(
  request: GetEndUserRequest
): Promise<GetEndUserResponse> {
  const response = await apiClient.get<GetEndUserResponse>(
    `/end-user/${encodeURIComponent(String(request.endUserId))}`
  );
  return response.data;
}

export async function updateEndUser({
  endUserId,
  ...endUserData
}: EditEndUserRequest): Promise<EditEndUserResponse> {
  const response = await apiClient.patch<EditEndUserResponse>(
    `/end-user/${endUserId}`,
    endUserData
  );
  return response.data;
}

export async function deleteEndUser(
  request: DeleteEndUserRequest
): Promise<DeleteEndUserResponse> {
  const response = await apiClient.delete<DeleteEndUserResponse>(
    `/end-user/${request.endUserId}`
  );

  return response.data;
}

export async function createEndUser(
  endUserData: CreateEndUserRequest
): Promise<CreateEndUserResponse> {
  const response = await apiClient.post<CreateEndUserResponse>(
    "/end-user",
    endUserData
  );
  return response.data;
}

export async function getEndUserFilters(
  request: GetFiltersRequest
): Promise<GetFiltersResponse> {
  const response = await apiClient.get<GetFiltersResponse>(
    "/end-user/filters",
    {
      params: {
        field: request.field,
        subCategoryQuery: request.subCategoryQuery,
        limit: request.limit,
        afterKey: request.afterKey,
      },
    }
  );
  return response.data;
}
